import React from 'react';
import { motion } from 'framer-motion';
import './ExpertSection.css';

const ExpertSection = () => {
  return (
    <section id="experts" className="expert-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="expert-content"
        >
          <div className="expert-header">
            <h2>Our Expert Vocal Coaches</h2>
            <p>Learn from industry professionals who have worked with top artists and have years of experience in playback singing, classical music, and vocal training.</p>
          </div>
          
          <div className="expert-grid">

          <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757840513659Ramya%20NSK%20profile.jpg?generation=1757840507189806&alt=media" 
                  alt="Ramya NSK" 
                />
              </div>
              <div className="expert-info">
                <h3>Ramya NSK</h3>
                <p>Playback Singer & Western Vocal Coach</p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757841567287aprna.png?generation=1757841560218256&alt=media" 
                  alt="Aparna Narayanan" 
                />
              </div>
              <div className="expert-info">
                <h3>Aparna Narayanan</h3>
                <p>Playback Singer & Vocal Coach</p>
              </div>
            </motion.div>

          <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757840534148DSC00152.JPG?generation=1757840531601802&alt=media" 
                  alt="Bhargavi Sridhar" 
                />
              </div>
              <div className="expert-info">
                <h3>Bhargavi Sridhar</h3>
                <p>Playback Singer & Carnatic Expert</p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757841082127reshmi.png?generation=1757841077124719&alt=media" 
                  alt="Reshmi" 
                />
              </div>
              <div className="expert-info">
                <h3>Reshmi</h3>
                <p>Playback Singer & Vocal Coach</p>
              </div>
            </motion.div>


            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757841008403monisha.jpg?generation=1757841000614075&alt=media" 
                  alt="Monisha Rathinavelu" 
                />
              </div>
              <div className="expert-info">
                <h3>Monisha Rathinavelu</h3>
                <p>Carnatic Trainer</p>
              </div>
            </motion.div>


            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757840524717DSC07943.JPG?generation=1757840520196342&alt=media" 
                  alt="Charumathi Muralidaran" 
                />
              </div>
              <div className="expert-info">
                <h3>Charumathi Muralidaran</h3>
                <p>Vocal Coach & Film Song Trainer</p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
              className="expert-card"
            >
              <div className="expert-image">
                <img 
                  src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757840550695DSC00012.JPG?generation=1757840542587215&alt=media" 
                  alt="Abishek Raju" 
                />
              </div>
              <div className="expert-info">
                <h3>Abishek Raju</h3>
                <p>Playback Singer, Devotional & Carnatic Expert</p>
              </div>
            </motion.div>


            {/* And Many More Card */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.0 }}
              viewport={{ once: true }}
              className="expert-card and-more-card"
            >
              <div className="expert-info">
                <h3>& many more</h3>
                {/* <p>Expert Vocal Coaches</p> */}
              </div>
            </motion.div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ExpertSection;
